<template>
  <RevDialog
    :name="MODAL_NAMES.SWAP_SUMMARY"
    :title="i18n(translations.buybackSwapSummaryTradeSummaryModalTitle)"
  >
    <template #body>
      <div>
        <div class="heading-3 mb-12">
          {{ i18n(translations.buybackSwapSummaryTradeSummaryModalBodyTitle) }}
        </div>
        <div class="mb-52">
          <FormattedMessage
            class="body-1"
            :definition="
              translations.buybackSwapSummaryTradeSummaryModalBodyDescription
            "
          >
            <template #tradein>
              <span class="body-1-bold">
                {{ i18n.price(price) }}</span
              ></template
            >
            <template v-if="totalPriceAfterBuyback" #totalprice>
              {{ i18n.price(totalPriceAfterBuyback) }}
            </template>
          </FormattedMessage>
        </div>
        <RevTextList variant="ordered">
          <RevTextListItem
            v-for="{ label, title: titleDetail } in tradeInDetailsModal"
            :key="label"
            class="mb-24 flex items-center gap-24"
          >
            <div class="flex flex-col">
              <div class="body-1-bold mb-8">{{ titleDetail }}</div>
              <div class="body-2">{{ label }}</div>
            </div>
          </RevTextListItem>
        </RevTextList>
      </div>
    </template>
  </RevDialog>
</template>

<script setup lang="ts">
import { computed } from 'vue'

import type { Price } from '@backmarket/http-api'
import { BUYBACK_SHIPPING_MODE } from '@backmarket/http-api/src/api-specs-buyback/constants'
import type { GetOfferResponseLegacy } from '@backmarket/http-api/src/api-specs-buyback/customer/getOfferLegacy'
import FormattedMessage from '@backmarket/nuxt-module-i18n/FormattedMessage.vue'
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevDialog } from '@ds/components/Dialog'
import { RevTextList } from '@ds/components/TextList'
import { RevTextListItem } from '@ds/components/TextListItem'

import { MODAL_NAMES } from '~/scopes/buyback/constants'

import translations from './SummaryCartModal.translations'

const { shippingMode } = defineProps<{
  price: Price
  totalPriceAfterBuyback?: Price
  shippingMode?: GetOfferResponseLegacy['defaultShippingModeId']
}>()

const i18n = useI18n()

const tradeInDetailsModalShipping = computed(() => {
  if (shippingMode && shippingMode === BUYBACK_SHIPPING_MODE.NEW_KIT) {
    return {
      title: i18n(
        translations.buybackSwapSummaryTradeSummaryModalDetailsBoxTitle,
      ),
      label: i18n(
        translations.buybackSwapSummaryTradeSummaryModalDetailsBoxLabel,
      ),
    }
  }
  if (shippingMode && shippingMode === BUYBACK_SHIPPING_MODE.QR_CODE) {
    return {
      title: i18n(
        translations.buybackSwapSummaryTradeSummaryModalDetailsQrCodeTitle,
      ),
      label: i18n(
        translations.buybackSwapSummaryTradeSummaryModalDetailsQrCodeLabel,
      ),
    }
  }

  return {
    title: i18n(
      translations.buybackSwapSummaryTradeSummaryModalDetailsNoBoxTitle,
    ),
    label: i18n(
      translations.buybackSwapSummaryTradeSummaryModalDetailsNoBoxLabel,
    ),
  }
})

const tradeInDetailsModal = computed(() => {
  return [
    tradeInDetailsModalShipping.value,
    {
      title: i18n(
        translations.buybackSwapSummaryTradeSummaryModalDetailsShippingTitle,
      ),
      label: i18n(
        translations.buybackSwapSummaryTradeSummaryModalDetailsShippingLabel,
      ),
    },
    {
      title: i18n(
        translations.buybackSwapSummaryTradeSummaryModalDetailsMoneyTitle,
      ),
      label: i18n(
        translations.buybackSwapSummaryTradeSummaryModalDetailsMoneyLabel,
      ),
    },
  ]
})
</script>
